module.exports = __webpack_public_path__ + "img/southernrock-gdas32.d969e4de.jpg";